<template>
  <Teleport to="body">
    <div :class="$style.outside" />
    <div :class="$style.container">
      <slot />
    </div>
  </Teleport>
</template>

<style module lang="scss" src="./Modal.scss" />
